import { createApiClient } from './ApiClientFactory.js'

const baseURL = import.meta.env.VITE_BASE_URL
const apiClient = createApiClient(`${baseURL}/chats`)

export default {
  async getConversations(params = {}) {
    const response = await apiClient.get('/', { params })
    return response.data
  },

  async getContacts(params = {}) {
    const response = await apiClient.get('/contacts', { params })
    return response.data
  },

  async getProfile() {
    const response = await apiClient.get('/me')
    return response.data
  },

  async getConversation(id, params = {}) {
    const response = await apiClient.get(`/${id}`, { params })
    return response.data
  },

  async createDirectConversation(payload) {
    const response = await apiClient.post('/direct', payload)
    return response.data
  },

  async sendMessage(conversationId, payload) {
    const response = await apiClient.post(`/${conversationId}/messages`, payload)
    return response.data
  },

  async markConversationRead(conversationId, payload = {}) {
    const response = await apiClient.post(`/${conversationId}/read`, payload)
    return response.data
  },

  async updateAiStatus(conversationId, aiStatus) {
    const response = await apiClient.patch(`/${conversationId}/ai-status`, { ai_status: aiStatus })
    return response.data
  },
}
